import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_cfg_tax_code_RowClass} from '../../../dbschema';

export class TaxCodeContainerModel extends BaseContainerModel {
  bl_fi_cfg_tax_code: bl_fi_cfg_tax_code_RowClass = new bl_fi_cfg_tax_code_RowClass();
}
